<template lang="pug">
div.shift-layout
  div.user-pool(@drop.prevent="onDrop('unset', $event)" @dragover.prevent="onDragover")
    h6 帳號清單
    div.user-item(v-for="user in users" :id="`user-${user.id}`" @drag="onDrag($event)" :userid="user.id" draggable) {{ user.last_name }}{{ user.first_name }}
  div.shift-schedule
    div.form-inline
      label.mr-2 排程日期
      input.form-control(type="date" v-model="currentDate" @change="getShift(currentDate)")
    table.table.table-sm.table-bordered
      thead
        tr.text-center
          th 床號
          th 值班人員
          th 流動人員 
          th 負責人員
      tbody
        tr.text-center(v-for="shiftRow in shiftTable")
          td(style="width: 50px") {{ shiftRow.bed.code }}
          td(@drop.prevent="onDrop('response' ,$event)" @dragover.prevent="onDragover" :bedid="shiftRow.bed.id")
            div.user-item(v-if="shiftRow.response.length > 0" v-for="shift in shiftRow.response") {{ shift.employee.last_name }}{{ shift.employee.first_name }}
              span.badge.badge-danger(@click="deleteShift(shift.shiftId)") X
          td(@drop.prevent="onDrop('circular', $event)" @dragover.prevent="onDragover" :bedid="shiftRow.bed.id")
            div.user-item(v-if="shiftRow.circular.length > 0" v-for="shift in shiftRow.circular") {{ shift.employee.last_name }}{{ shift.employee.first_name }}
              span.badge.badge-danger(@click="deleteShift(shift.shiftId)") X
          td(@drop.prevent="onDrop('management', $event)" @dragover.prevent="onDragover" :bedid="shiftRow.bed.id")
            div.user-item(v-if="shiftRow.management.length > 0" v-for="shift in shiftRow.management") {{ shift.employee.last_name }}{{ shift.employee.first_name }}
              span.badge.badge-danger(@click="deleteShift(shift.shiftId)") X
</template>

<script>
import moment from 'moment';
import _ from 'lodash';
import { mapState } from 'vuex';

export default {
  name: 'ShiftArrange',
  data() {
    return {
      users: [],
      draggedElementId: null,
      currentDate: null,
      todayShift: [],
      beds: [],
    };
  },
  computed: {
    instance() { return this.$store.getters.instance; },
    shiftTable() {
      const shiftTable = [];
      this.beds.forEach((bed) => {
        shiftTable.push({
          bed,
          response: [],
          circular: [],
          management: [],
        });
      });

      this.todayShift.forEach((shift) => {
        console.log(shift);
        const shiftItem = shiftTable[shift.bed.code - 1];
        shiftItem.bed.id = shift.bed.id;
        shiftItem[shift.employee_duty].push({ employee: shift.employee, shiftId: shift.id });
      });
      return shiftTable;
    },
  },
  methods: {
    getUsers(url) {
      this.instance.get(url)
      .then((res) => {
        if (res.data.next_page_url !== null) {
          this.getUsers(res.data.next_page_url);
        } else {
          this.users = this.users.concat(res.data.results);
          this.users = _.orderBy(this.users, ['last_name', 'first_name']);
        }
      });
    },
    getBedCount() {
      this.instance.get('/api/bed/')
      .then((res) => {
        this.beds = res.data;
      });
    },
    getShift(date) {
      this.instance.get('/api/shift', { params: { date } })
      .then((res) => { this.todayShift = res.data; });
    },
    onDrag(event) {
      this.draggedElementId = event.target.id;
    },
    onDragover(event) {
      // console.log('ondragover', event);
    },
    onDrop(droppedType, event) {
      const draggedElement = document.getElementById(this.draggedElementId);
      const data = {
        date: this.currentDate,
        employee: parseInt(draggedElement.getAttribute('userid'), 10),
        employee_duty: droppedType,
        bed: parseInt(event.target.getAttribute('bedid'), 10),
      };
      console.log(data);
      this.instance.post('/api/shift/', data)
      .then((res) => {
        this.getShift(this.currentDate);
      });
    },
    setShift() {
      //
    },
    deleteShift(id) {
      this.instance.delete(`/api/shift/${id}/`)
      .then((res) => {
        this.getShift(this.currentDate);
      });
    },
  },
  created() {
    this.getBedCount();
    this.getUsers('/api/user/');
    this.currentDate = moment().format('YYYY-MM-DD');
    this.getShift(this.currentDate);
  },
};
</script>

<style lang="sass">
.shift-layout
  display: flex


.user-pool
  width: 50%

.user-item
  background-color: steelblue
  color: white
  padding: 2px 6px
  display: inline-block
  font-size: 14px
  margin: 1px

.shift-schedule
  width: 50%
</style>




// WEBPACK FOOTER //
// ShiftArrange.vue?40c34d49